<template>
    <div class="single-slide">
        <img alt="DaySmart Vet" class="w-100" :src="require(`@/assets/DaySmartVet_reveal.gif`)">
    </div>
</template>
<style type="text/css">	
.single-slide{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>